import React, { useState, useEffect } from 'react';
import { useParams, useNavigate,useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/outline';
import axiosInstance from '../../axios';
import pdf from '../../imageAxios';

const CourseDetails = () => {
  const location=useLocation()
  const {course_id}=location.state||{}
  const navigate = useNavigate();
  const [course, setCourse] = useState({});
  const [aff, setAff] = useState('')
  const[smart,setSmart]=useState('')
  useEffect(() => {
    axiosInstance.get(`courses/get/${course_id}`)
      .then((res) => {
        setCourse(res.data);
        setAff(res.data.affli_certificate?`${pdf}/${res.data.affli_certificate}`:'');
        setSmart(res.data.smart_aff_certi?`${pdf}/${res.data.smart_aff_certi}`:'');
      })
      .catch((err) => console.log(err));
  }, [course_id]);
  const handleView = (url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      alert('Document not found');
    }
  };
  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="flex items-center justify-between bg-gray-100 p-4 border-b border-gray-400">
            <div className="flex items-center space-x-2">
              <ArrowLeftIcon
                className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-800 transition"
                onClick={() => navigate('/courses')}
              />
              <h1 className="text-xl font-semibold text-gray-700">Course Details</h1>
            </div>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
           
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Job Role Name</div>
                <div className="text-gray-600">{course.course_name}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Course Code</div>
                <div className="text-gray-600">{course.course_code}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Affiliation Agency</div>
                <div className="text-gray-600">{course.aff_agency}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">MESS Equivalence</div>
                <div className="text-gray-600">{course.mess_equivalance}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Minimum Qualification</div>
                <div className="text-gray-600">{course.min_quali}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Sector Name</div>
                <div className="text-gray-600">{course.sector_name}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Job Role Category</div>
                <div className="text-gray-600">{course.job_role_cate}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Job Role ID</div>
                <div className="text-gray-600">{course.job_role_id}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Version</div>
                <div className="text-gray-600">{course.version}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Core Skill Hours</div>
                <div className="text-gray-600">{course.core_skill_hour}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Soft Skill Hours</div>
                <div className="text-gray-600">{course.soft_skill_hour}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">OJT Hours</div>
                <div className="text-gray-600">{course.ojt_hour}</div>
              </div>
              
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Admin Status</div>
                <div className="text-gray-600">{course.admin_status}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Cost Category</div>
                <div className="text-gray-600">{course.cost_cate}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Affiliation Certificate</div>
                <div className="text-gray-600">
                {aff ? (
                    <button
                      onClick={() => handleView(aff)}
                      className="text-blue-500 hover:underline"
                    >
                      View Affiliation Certificate
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">SMART Affiliation Certificate</div>
                <div className="text-gray-600">
                  {smart ? (
                    <button
                      onClick={() => handleView(smart)}
                      className="text-blue-500 hover:underline"
                    >
                      View SMART Affiliation
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Cost</div>
                <div className="text-gray-600">{course.cost}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
